export const isParentNotStediDomain = (isMounted: boolean) => {
  if (!isMounted) {
    return false;
  }

  try {
    /**
     * In theory this check is not necessary since the `window.parent.location.hostname` property access SHOULD result in an error in all modern browsers.
     * We opted to make the check explicitly because:
     * 1. We are not comfortable relying only on the fact that the property access causes an error.
     * 2. We want to make sure that if some kind of browser follows different heuristics for the property access, we are not relying on it.
     */
    const hostname = window.parent.location.hostname;
    return hostname !== "stedi.com" && hostname !== "www.stedi.com";
  } catch (_e) {
    // When embedded on a non-stedi domain, an attempt to access `window.parent.location.hostname` would result in exception,
    // so we can safely assume we are embedded on a 3rd party website.
    return true;
  }
};
